import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getMsDynamicsCrmSettings, saveMsDynamicsCrmSettings} from 'src/openapi/admin/apis/MsDynamicsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CrmAccountSettings} from 'src/openapi/admin/models/CrmAccountSettings';

type Props = {
    accountId: number,
};

export const useMsDynamicsSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getMsDynamicsCrmSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback(async (crmAccountSettings: CrmAccountSettings) => await apiDispatch(
        saveMsDynamicsCrmSettings({accountId, crmAccountSettings}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        shouldLoadData: false,
        initValue: {
            accountSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
            },
            contactSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
                importEnabled: false,
            },
            leadSettings: {
                autoSyncEnabled: false,
                autoLinkEnabled: false,
                importEnabled: false,
            },
            alertsEnabled: false,
        },
    });
};
